import { render, staticRenderFns } from "./OpenCardButton.vue?vue&type=template&id=74da3a84&scoped=true&"
import script from "./OpenCardButton.vue?vue&type=script&lang=ts&"
export * from "./OpenCardButton.vue?vue&type=script&lang=ts&"
import style0 from "./OpenCardButton.vue?vue&type=style&index=0&id=74da3a84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da3a84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
